export default "__VITE_ASSET__NuHJcCSi__"